import React, { useState, useEffect } from 'react'
import parentStyles from '../styles.module.scss'
import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts'
import { getDateFormatRange1 } from 'srcReact/helpers/datetimeHelper'

function EngagementActivityGraph({ countGraphData, rateGraphData }) {
  const [data, setData] = useState([])

  useEffect(() => {
    if (rateGraphData?.length > 0) {
      setData([
        {
          name: getDateFormatRange1(rateGraphData[3].period_start_at, rateGraphData[3].period_end_at),
          uv: parseInt(countGraphData[3].value),
          percent: rateGraphData[3].value === '0' ? '' : `${rateGraphData[3].value}%`
        },
        {
          name: getDateFormatRange1(rateGraphData[2].period_start_at, rateGraphData[2].period_end_at),
          uv: parseInt(countGraphData[2].value),
          percent: rateGraphData[2].value === '0' ? '' : `${rateGraphData[2].value}%`
        },
        {
          name: getDateFormatRange1(rateGraphData[1].period_start_at, rateGraphData[1].period_end_at),
          uv: parseInt(countGraphData[1].value),
          percent: rateGraphData[1].value === '0' ? '' : `${rateGraphData[1].value}%`
        },
        {
          name: getDateFormatRange1(rateGraphData[0].period_start_at, rateGraphData[0].period_end_at),
          uv: parseInt(countGraphData[0].value),
          percent: rateGraphData[0].value === '0' ? '' : `${rateGraphData[0].value}%`
        }
      ])
    }
  }, [rateGraphData])

  return (
    <div className={parentStyles.graph}>
      <ResponsiveContainer>
        <BarChart data={data} stackOffset={'expand'} barCategoryGap={'15%'}>
          <CartesianGrid strokeArray='5' strokeWidth={2} stroke='#d4d4e0' vertical={false} />
          <XAxis
            dataKey='name'
            strokeWidth={2}
            stroke={'#28363d'}
            tick={{ fontSize: 10, fill: '#28363d' }}
            dy={10}
            interval={0}
          />
          <YAxis domain={[0, 'dataMax + 20']} hide={true} />
          <Bar maxBarSize={50} barGap={0} dataKey='uv' fill='#feb200' isAnimationActive={true}>
            <LabelList dataKey='uv' position='top' style={{ fontSize: '14px', fontWeight: 'bold', fill: '#feb200' }} />
            <LabelList
              dataKey='percent'
              position='center'
              style={{ fontSize: '12px', fontWeight: 'bold', fill: '#fff' }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default EngagementActivityGraph
